const allKey = 'STATUS_ALL';
const draftKey = 'STATUS_DRAFT';
const activeKey = 'STATUS_ACTIVE';
const closedKey = 'STATUS_CLOSED';
const reportedKey = 'STATUS_REPORTED';
const archivedKey = 'STATUS_ARCHIVED';
const cancelledKey = 'STATUS_CANCELLED';

const eventStatusConstants = Object.freeze({
  [allKey]: { value: undefined, name: 'Alla', key: allKey },
  [draftKey]: { value: 0, name: 'Utkast', key: draftKey },
  [activeKey]: { value: 2, name: 'Aktivt', key: activeKey },
  [closedKey]: { value: 3, name: 'Stängt', key: closedKey },
  [reportedKey]: { value: 4, name: 'Rapporterat', key: reportedKey },
  [archivedKey]: { value: 5, name: 'Arkiverat', key: archivedKey },
  [cancelledKey]: { value: 6, name: 'Inställt', key: cancelledKey },
});

export default eventStatusConstants;

export const findEventStatusByValue = (value) => Object.values(eventStatusConstants)
  .find((status) => status.value === value) || eventStatusConstants.STATUS_ALL;
